import { Form, Input, Modal, Select } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { API } from '../../../api';
import BranchSelect from '../../../lib/BranchSelect';
interface Props {
  open?: boolean;
  onOk: any;
  chuteCode: number;
  onCancel: any;
}

interface StateInterface {
  chuteCode: string;
  machineCode: string;
  planList?: any[];
  branchNo?: string;
}
export const SortingEdit = ({ open, onOk, onCancel, chuteCode }: Props) => {
  const [state, changeState] = useState<StateInterface>({
    chuteCode: '0',
    machineCode: 'default',
    // branchNo: null,
  });
  const [branchList, changeBranchList] = useState<any[]>([]);
  useEffect(() => {
    fetchBranchList();
  }, []);
  useEffect(() => {
    if (open) {
      changeState({
        chuteCode: chuteCode + '',
        machineCode: 'default',
        // branchNo: null,
      });
    }
  }, [open, chuteCode]);
  const fetchBranchList = async () => {
    try {
      const response = await API.get({ apiVersion: 'api', withCredentials: true })(
        '/settings/branch/list'
      );
      changeBranchList(response.result.branchList);
      console.log(response.result.branchList);
    } catch (e) {}
  };
  const onSubmit = useCallback(async () => {
    try {
      const response = await API.post({ apiVersion: 'api' })('/sorter/branch/update', {
        ...state,
        chuteCode: parseInt(state.chuteCode),
      });
      onOk();
    } catch (e) {}
  }, [state]);
  return (
    <Modal open={open} onCancel={onCancel} onOk={onSubmit}>
      <Form>
        <Form.Item label="Салбар">
          <BranchSelect
            showSearch
            value={state.branchNo}
            onChange={(e: any) => changeState({ ...state, branchNo: e })}
          />
        </Form.Item>
        <Form.Item label="chutecode">
          <Input
            type="number"
            onChange={(e) => changeState({ ...state, chuteCode: e.target.value })}
            value={state.chuteCode}
          />
        </Form.Item>
        <Form.Item label="machinecode">
          <Input
            value={state.machineCode}
            onChange={(e) => changeState({ ...state, machineCode: e.target.value })}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};
